import React from 'react';
import styles from './DetailsTab.module.scss';
import WhiteContainer from '../../../../HOC/WrappingContainer/WhiteContainer';
import TextContainer from '../../../../Atoms/CustomizedAtoms/TextContainer';
import availableIcon from '../../../../../assets/Imagess/availableICon.svg';
import UnavailableIcon from '../../../../../assets/Imagess/notAvailableIcon.svg';

const DetailsTab = ({ data }) => {
  return (
    <WhiteContainer white>
      <h3 className={styles.title}>Contact Details</h3>

      <TextContainer title='Contact Type' data={data?.contactTypeName} />
      <TextContainer title='Country' data={data?.countryName} />
      <TextContainer title='Nationality' data={data?.nationalityName} />
      <TextContainer title='Language' data={data?.languageName} />
      <TextContainer title='Job Title' data={data?.jobTitle} />
      <TextContainer title='Grade' data={data?.gradeName} />
      <TextContainer title='High School GPA' data={data?.highSchoolGPA} />
      <TextContainer title='Curriculum' data={data?.curriculumName} />
      <TextContainer title='Priority' data={data?.priorityName} />

      {data?.sendMailer && (
        <div className={styles.sendMailer}>
          <img src={availableIcon} alt='available' className={styles.icon} />
          <span> Send Mailer</span>
        </div>
      )}
    </WhiteContainer>
  );
};

export default DetailsTab;
